import _default from './Pagination';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Pagination/index.js
// module id = 3235
// module chunks = 0